import get from 'lodash/get';
import { ContentItem } from 'kentico-cloud-delivery';


export default class ImageLink extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
      richTextResolver: item => `<a href='${item.url}' target='${item.blank}' rel='${item.nofollow}'>
                                    <img src='${item.image.url}' alt='${item.image.description}' />
                                  </a>`,
    });
  }

  get type() {
    return get(this, 'system.type', '');
  }

  get url() {
    return get(this, '_url.value', '');
  }

  get nofollow() {
    return get(this, '_rel_nofollow.value[0].name', '');
  }

  get blank() {
    return get(this, '_target_blank.value[0].name', '');
  }

  get image() {
    return get(this, '_image.value[0]', '');
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get id() {
    return get(this, 'system.id', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ImageLink.model.js